import PointListPanel from './pointListPanel.container'

export default PointListPanel